import React, { ReactNode } from 'react';
import { styles } from './HeroBlock.css';
import { CardGrid, CardGridCardProps, CardGridVariant } from '../Card/CardGrid/CardGrid';

export interface HeroBlockProps {
  heading?: ReactNode;
  cards?: Array<CardGridCardProps>;
  launchTiles?: ReactNode;
  footer?: ReactNode;
  breakToCarousel?: boolean;
  enableContainerBreakpoints?: boolean;
  testId?: string;
}

export const HeroBlock: React.FC<HeroBlockProps> = ({
  heading,
  cards = [],
  launchTiles,
  footer,
  breakToCarousel = false,
  enableContainerBreakpoints = false,
  testId,
}) => {
  return (
    <div className={styles.container}>
      {heading ? <div className={styles.heading}>{heading}</div> : null}
      <CardGrid
        cards={cards}
        variant={CardGridVariant.withPrimary}
        isCarousel={breakToCarousel ? { xs: true, md: false } : false}
        enableContainerBreakpoints={enableContainerBreakpoints}
      />
      {launchTiles ? <div className={styles.launchTiles}>{launchTiles}</div> : null}
      {footer ? (
        <div className={styles.footer} data-testid={`${testId}-footer`}>
          {footer}
        </div>
      ) : null}
    </div>
  );
};
